"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadspediaApiBase = void 0;
const Lead_1 = require("./Lead");
class LeadspediaApiBase {
    constructor({ client, campaign }) {
        this.plugins = [];
        this.actions = client;
        this.campaign = campaign;
    }
    /** Creates a new Lead instance */
    new(initialState, leadProps) {
        const events = {};
        initialState = this.plugins.reduce((newInitialState, plugin) => {
            if (plugin.onLoad)
                return (plugin.onLoad(newInitialState));
            return newInitialState;
        }, initialState);
        const lead = new Lead_1.Lead(this.actions, {
            initialState,
            campaign: (leadProps === null || leadProps === void 0 ? void 0 : leadProps.campaign) || this.campaign,
            requiredPartialFields: leadProps === null || leadProps === void 0 ? void 0 : leadProps.requiredPartialFields,
            test: leadProps === null || leadProps === void 0 ? void 0 : leadProps.test,
            events: {
                onUpdate(state) {
                    var _a;
                    (_a = events.onUpdate) === null || _a === void 0 ? void 0 : _a.forEach((cb) => {
                        cb(state);
                    });
                },
                onMerge(mergeState, oldState) {
                    return events.onMerge
                        ? events.onMerge.reduce((newState, cb) => (cb(newState, oldState)), mergeState)
                        : mergeState;
                },
                onFieldUpdate(key, value) {
                    return events.onFieldUpdate
                        ? events.onFieldUpdate.reduce((newValue, cb) => (cb(key, newValue)), value)
                        : value;
                },
            },
        });
        this.plugins.forEach((plugin) => {
            if (typeof plugin === "object") {
                return;
            }
            const pluginStruct = plugin(lead);
            Object.entries(pluginStruct).forEach(([key, cb]) => {
                const eventListeners = events[key] || (events[key] = []);
                eventListeners.push(cb);
            });
        });
        return lead;
    }
    use(...plugins) {
        this.plugins.push(...plugins);
    }
}
exports.LeadspediaApiBase = LeadspediaApiBase;
//# sourceMappingURL=LeadspediaApiBase.js.map